(function () {
  function openCookiePreferences(event) {
    if (event) {
      event.preventDefault();
    }

    if (typeof privacyBanner !== 'undefined' && typeof privacyBanner.showPreferences === 'function') {
      privacyBanner.showPreferences();
      return;
    }

    window.Shopify = window.Shopify || {};
    if (typeof window.Shopify.loadFeatures !== 'function') {
      return;
    }

    window.Shopify.loadFeatures([], function () {
      if (typeof privacyBanner !== 'undefined' && typeof privacyBanner.showPreferences === 'function') {
        privacyBanner.showPreferences();
      }
    });
  }

  function bindTriggers() {
    document.querySelectorAll('[data-cookie-preferences-trigger]').forEach(function (element) {
      element.addEventListener('click', openCookiePreferences);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTriggers);
  } else {
    bindTriggers();
  }

  window.VecickyCookiePreferences = {
    open: openCookiePreferences,
  };
})();
